"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var CircleGraph_1 = __importDefault(require("atomicComponents/atoms/Graphs/CircleGraph"));
var AuditScore = function (_a) {
    var score = _a.score;
    return (0, jsx_runtime_1.jsx)(CircleGraph_1.default, { value: score, title: "of 100", size: 160 });
};
exports.default = AuditScore;
